import React, { useState } from 'react';
import sunflower from './imgs/sunflower.png';
import turtle from './imgs/turtle.png';
import rose from './imgs/rose.png';
import ele from './imgs/elephant.jpeg';
import bags from './imgs/bags.png';
import './Styles/products.css';

const productsData = [
  { 
    id: 1, 
    name: 'Sunflower Stitch', 
    price: 199, 
    image: sunflower,
    description: 'Beautiful hand-embroidered sunflower design',
    category: 'Embroidery'
  },
  { 
    id: 2, 
    name: 'Turtles', 
    price: 550, 
    image: turtle,
    description: 'Cute crochet turtle set',
    category: 'Crochet'
  },
  { 
    id: 3, 
    name: 'Roses', 
    price: 450, 
    image: rose,
    description: 'Elegant embroidered rose pattern',
    category: 'Embroidery'
  },
  { 
    id: 4, 
    name: 'Elephant', 
    price: 1150, 
    image: ele,
    description: 'Detailed knitted elephant design',
    category: 'Knitting'
  },
  { 
    id: 5, 
    name: 'Denim Bags', 
    price: 1250, 
    image: bags,
    description: 'Handcrafted embroidered denim bags',
    category: 'Embroidery'
  }
];

const Product = ({ product, addToCart }) => (
  <div className="product-card">
    <div className="product-image">
      <img src={product.image} alt={product.name} />
    </div>
    <div className="product-info">
      <h3>{product.name}</h3>
      <p className="product-description">{product.description}</p>
      <p className="product-price">₹{product.price}</p>
      <button className="btn-cart" onClick={() => addToCart(product)}>
        Add to Cart
      </button>
    </div>
  </div>
);

const Cart = ({ cartItems, removeFromCart }) => {
  const calculateTotal = () => {
    return cartItems.reduce((total, item) => total + item.price, 0);
  };

  const totalAmount = calculateTotal();

  const generateWhatsAppLink = () => {
    const itemsList = cartItems.map(item => 
      `${item.name} - ₹${item.price}`
    ).join('\n');
    
    const message = `Order Details:\n\n${itemsList}\n\nTotal Amount: ₹${totalAmount}`;
    const phoneNumber = '9324409384';
    return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  };

  return (
    <div className="cart">
      <h2>Shopping Cart</h2>
      {cartItems.length === 0 ? (
        <p className="empty-cart">Your cart is empty</p>
      ) : (
        <>
          <ul className="cart-items">
            {cartItems.map((item, index) => (
              <li key={index} className="cart-item">
                <span>{item.name}</span>
                <span>₹{item.price}</span>
                <button 
                  className="remove-btn"
                  onClick={() => removeFromCart(index)}
                >
                  ×
                </button>
              </li>
            ))}
          </ul>
          <div className="cart-total">
            <p>Total Amount: ₹{totalAmount}</p>
          </div>
          <a 
            href={generateWhatsAppLink()} 
            target="_blank" 
            rel="noopener noreferrer"
            className="checkout-btn"
          >
            Checkout on WhatsApp
          </a>
        </>
      )}
    </div>
  );
};

const App = () => {
  const [cartItems, setCartItems] = useState([]);
  const [showCart, setShowCart] = useState(false);

  const addToCart = (product) => {
    setCartItems([...cartItems, product]);
    setShowCart(true);
  };

  const removeFromCart = (index) => {
    const newCartItems = cartItems.filter((_, i) => i !== index);
    setCartItems(newCartItems);
    if (newCartItems.length === 0) {
      setShowCart(false);
    }
  };

  return (
    <div className="products-container">
      <div className="products-grid">
        {productsData.map((product) => (
          <Product 
            key={product.id} 
            product={product} 
            addToCart={addToCart} 
          />
        ))}
      </div>
      {showCart && (
        <Cart 
          cartItems={cartItems} 
          removeFromCart={removeFromCart}
        />
      )}
    </div>
  );
};

export default App;
